import React from 'react';
import { supabase } from '../lib/supabase';

interface PlaylistStructuredDataProps {
  playlist: {
    id: string;
    spotify_id: string;
    name: string;
    description: string;
    image_url: string;
    followers: number;
    track_count: number;
    genre: string;
    sub_genres: string[];
    curator_name: string | null;
    curator_profile_url: string | null;
    updated_at: string;
  };
  baseUrl: string;
}

export function PlaylistStructuredData({ playlist, baseUrl }: PlaylistStructuredDataProps) {
  const schema = {
    "@context": "https://schema.org",
    "@type": "MusicPlaylist",
    "name": playlist.name,
    "description": `Get your music featured on ${playlist.name}, a Spotify playlist curated by ${playlist.curator_name} with ${playlist.followers.toLocaleString()} followers. No account needed! Access thousands of playlists and connect with curators on PlaylistPartner.com.`,
    "numTracks": playlist.track_count,
    "url": `${baseUrl}/playlist/${playlist.spotify_id}`,
    "sameAs": [
      `https://open.spotify.com/playlist/${playlist.spotify_id}`,
    ],
    "dateModified": playlist.updated_at,
    "image": playlist.image_url,
    "author": {
      "@type": "Person",
      "name": playlist.curator_name,
      "url": playlist.curator_profile_url
    },
    "genre": [
      playlist.genre,
      ...(playlist.sub_genres?.slice(0, 2) || [])
    ].filter(Boolean),
    "interactionStatistic": {
      "@type": "InteractionCounter",
      "interactionType": "https://schema.org/FollowAction",
      "userInteractionCount": playlist.followers
    },
    "isPartOf": {
      "@id": baseUrl
    }
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schema)}
    </script>
  );
} 